<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :filter="filter"
        module="basic"
        url="esops"
        :columns-property="columnsProperty"
        :table-select="false"
        @reset="resetHandle"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="文件编号">
              <el-input v-model.trim="filter.esopNo" placeholder="请输入文件编号" clearable/>
            </el-form-item>
            <el-form-item label="文件名称">
              <el-input v-model.trim="filter.esopName" placeholder="请输入文件名称" clearable/>
            </el-form-item>
            <el-form-item label="文件类型">
              <el-select v-model="filter.fileType" placeholder="请选择文件类型" clearable>
                <el-option label="受控" :value="10"/>
                <el-option label="试行" :value="20"/>
                <el-option label="样品" :value="30"/>
              </el-select>
            </el-form-item>
            <el-form-item label="文件状态">
              <el-select v-model="filter.status" placeholder="请选择文件状态" clearable>
                <el-option label="未提交" :value="0"/>
                <el-option label="审核退回" :value="5"/>
                <el-option label="审核中" :value="6"/>
                <el-option label="审核通过" :value="10"/>
              </el-select>
            </el-form-item>
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input v-model.trim="filter.specification" placeholder="请输入规格型号" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>

      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.downAuth"
            type="primary"
            @click="downHandle(scope.row.filePath)"
        >
          下载
        </el-button>
        <el-button
            v-if="limits.subAuth"
            type="primary"
            :disabled="![0, 5].includes(scope.row.status)"
            @click="submitHandle(scope.row.pkId)"
        >
          提交
        </el-button>
        <el-button
            v-if="limits.changeAuth"
            type="primary"
            :disabled="scope.row.status !== 10"
            @click="$refs.esopEdit.open(scope.row, 'replaceHandle')"
        >
          变更
        </el-button>
      </template>
    </view-table>
    <!-- 新增编辑 -->
    <esop-edit ref="esopEdit" @save-success="loadData(1)"/>
    <!-- 变更记录 -->
    <replace-record ref="replaceRecord"/>
    <pdf-preview-index ref="pdfPreview"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import EsopEdit from "./EsopEdit.vue";
  import ReplaceRecord from "./ReplaceRecord.vue";
  import PdfPreviewIndex from "@/views/information/Esop/PdfPreviewIndex";

  export default {
    name: "EsopList",
    components: {
      ViewTable,
      EsopEdit,
      ReplaceRecord,
      PdfPreviewIndex,
    },
    data() {
      return {
        limits: {
          addAuth: this.$auth(193),
          editAuth: this.$auth(195),
          delAuth: this.$auth(197),
          subAuth: this.$auth(194),
          changeAuth: this.$auth(196),
        },
        filter: {
          esopNo: "",
          esopName: "",
          fileType: "",
          status: "",
          materialNo: "",
          specification: "",
        },
        billId: "",
        billType: "",
        columnsProperty: [
          {
            key: "esopNo",
            width: 120,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.replaceRecordClick(params.row);
                      // this.$refs.replaceRecord.open(params.row);
                    },
                  },
                },
                params.row.esopNo,
              );
            },
          },
          {
            key: "esopName",
            tooltip: true,
            minWidth: 200,
          },
          {
            key: "filePath",
            tooltip: true,
            width: 120,
            render: (h, params) => {
              return h(
                "span", {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.download(params.row.filePath);
                    },
                  },
                },
                params.row.filePath,
              );
            },
          },
          {
            key: "fileTypeName",
            width: 100,
            align: "center",
          },
          {
            key: "statusName",
            width: 120,
            align: "center",
          },
          {
            key: "materialNo",
            width: 120,
            align: "center",
          },
          {
            key: "materialName",
            minWidth: 240,
            tooltip: true,
            align: "left",
          },
          {
            key: "specification",
            minWidth: 180,
            tooltip: true,
            align: "center",
          },
          {
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            key: "createTime",
            width: 160,
            align: "left",
          },
          {
            key: "action",
            width: 240,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    methods: {
      replaceRecordClick(row) {
        this.$http
          .get("basic", `esops/${row.pkId}`)
          .then((resp) => {
            if (resp.success) {
              this.billId = resp.data.esopChangeId + "";
              this.billType = resp.data.workFlowType + "";
              this.$refs.replaceRecord.open(resp.data, this.billId, this.billType);
            }
          });
      },
      download(filePath) {
        this.$refs.pdfPreview.open(filePath);

        // this.$http.get("basic", `files/getDownloadUrl?key=${filePath}`).then((res) => {
        //   if (res.success) {
        //     // window.open(res.data);
        //     this.$refs.pdfPreview.open(res.data);
        //   }
        // });

        // this.$http.get("basic", `files/getDownloadUrl?key=${filePath}`).then((res) => {
        //   if (res.success) {
        //     this.$refs.pdfPreview.open(res.data);
        //   }
        // }).catch(() => {
        // });
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.esopEdit.open(row);
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "esops", row.pkId).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      // 提交
      submitHandle(pkId) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", `esops/submit/${pkId}`).then((res) => {
            if (res.success) {
              this.$message.success("提交成功");
              this.loadData(1);
            }
          });
        });
      },

      otherAuth(row) {
        if (row.status === 0) {
          return {
            editAuth: false,
            delAuth: false,
          };
        } else if (row.status === 5) {
          return {
            editAuth: false,
            delAuth: true,
          };
        } else {
          return {
            editAuth: true,
            delAuth: true,
          };
        }
      },
    },
  };
</script>

<style lang="scss">
.ivu-table td,
.ivu-table th {
  height: 37px;
  font-size: 13px;

  .el-button--mini {
    padding: 7px 10px;
  }
}
</style>
